export const processAnnotationResponse = (response) => {
  // for data: GET response is array, POST response is object
  const responseData = Array.isArray(response.data) ? response.data : [response.data];

  const history = !responseData.length ? [] : responseData.map((annotation) => {
    const { author, parent, version } = annotation.relationships;
    return {
      id: annotation.id,
      author: author && author.data ? author.data.id : '',
      parent: parent && parent.data ? parent.data.id : '',
      version: version.data.id,
      type: annotation.attributes.x_offset_in_percentage ? "annotation" : "comment",
      ...annotation.attributes,
    };
  });

  const users = {};
  if (response.included && response.included.length) {
    response.included.forEach((includedItem) => {
      if (includedItem.type === 'users') {
        users[includedItem.id] = { ...includedItem.attributes };
      }
    });
  }

  return { history, users };
};
